import queryString from 'query-string';
import { generatePath } from 'react-router';
import {
  DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, getCurrentLocalization
} from './i18n';

export const externalRoutes = {
  aiSearchResult: 'externalRoutes.ai_search_result'
};

const defaultExternalRoutePatterns = {
  [externalRoutes.aiSearchResult]: '/search'
};

export const getExternalRoutePath = (t, routeKey, pathParams = {}) => {
  const translatedPattern = t(routeKey);
  const routePattern = translatedPattern !== routeKey
    ? translatedPattern
    : defaultExternalRoutePatterns[routeKey];

  if (!routePattern) {
    throw new Error(`Unknown external route: ${ routeKey }`);
  }

  return generatePath(routePattern, pathParams);
};

const prefixExternalRouteWithLocale = ({
  pathname,
  lang,
  defaultLanguage,
  supportedLanguages
}) => {
  if (lang === defaultLanguage || !supportedLanguages.includes(lang)) {
    return pathname || '/';
  }

  return `/${ lang }${ pathname }`;
};

export const buildExternalRouteTarget = (t, routeKey, {
  pathParams = {},
  queryParams = {},
  lang = getCurrentLocalization(),
  defaultLanguage = DEFAULT_LANGUAGE,
  supportedLanguages = SUPPORTED_LANGUAGES
} = {}) => {
  const pathname = prefixExternalRouteWithLocale({
    pathname: getExternalRoutePath(t, routeKey, pathParams),
    lang,
    defaultLanguage,
    supportedLanguages
  });
  const search = queryString.stringify(queryParams);

  return search ? `${ pathname }?${ search }` : pathname;
};
